var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors !== null && _vm.errors.length > 0)?_c('base-alert',{attrs:{"type":"error"}},[_c('ul',{class:[_vm.errors.length > 1 ? 'list-disc' : 'list-none']},_vm._l((_vm.errors),function(errorMessage,index){return _c('li',{key:index},[_vm._v("\n            "+_vm._s(errorMessage)+"\n        ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }